import { useState, useEffect, useContext } from 'react';
import Modal from 'react-bootstrap/Modal';
import { getPrescribers } from '../API/prescriber';
import { getGroupPractices } from '../API/groupPractice';
import { getGeographyAggregates } from '../API/geographyAggregate';
import { getConfigValue } from '../util/getConfigValue';
import { AppContext } from '../util/AppContext';

import PropType from 'prop-types';
import SelectTargetComponent from './SelectTargetComponent';
import { hcpTab } from '../util/constants.js';

ProvidersModal.propTypes = {
	show: PropType.bool,
	setShow: PropType.func,
	onProviderClick: PropType.func,
	currentProvider: PropType.string,
};

function ProvidersModal({ show, setShow, onProviderClick, currentProvider }) {
	const [appState, setAppState] = useContext(AppContext);
	const [selectedProvider, setSelectedProvider] = useState();
	const [searchInput, setSearchInput] = useState('');
	const [showResults, setShowResults] = useState(false);

	let timer;
	useEffect(() => {
		// cleanup
		return () => {
			if (timer) {
				clearTimeout(timer);
			}
		};
	}, []);

	useEffect(() => {
		if (currentProvider === null) {
			setSelectedProvider(currentProvider);
		}
	}, [currentProvider]);

	function resetModal() {
		// avoid showing reset changes in UI as modal closes
		timer = setTimeout(() => {
			setSearchInput('');
			setSelectedProvider(null);
		}, 250);
	}

	function handleSelect() {
		onProviderClick(selectedProvider);
		resetModal();
	}

	function handleHide() {
		setShow(false);
		resetModal();
	}

	function handleChange(event) {
		setSearchInput(event.target.value);
	}

	function handleActive(data) {
		// Find the provider from the getPrescribers results
		setSelectedProvider(data);
	}


	const filter = async function (data, filterText, hcpFavoritesOnly, activeTab) {
		let results = null;
		if (activeTab === hcpTab.Prescriber) {
			results = await getPrescribers(filterText, hcpFavoritesOnly);
		} else if (activeTab === hcpTab.GroupPractice) {
			results = await getGroupPractices(filterText, hcpFavoritesOnly);
		} else if (activeTab === hcpTab.GeographyAggregate) {
			results = await getGeographyAggregates(filterText, hcpFavoritesOnly);
		}
		return results ? results.rows : data;
	};

	return (
		<Modal show={show} onHide={handleHide} size='lg' scrollable>
			<Modal.Header className='primary' closeButton>
				<Modal.Title className='type-18'>{getConfigValue(appState.config?.ProviderModal?.Title, appState)?.Value || null}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<SelectTargetComponent
					filterFunction={filter}
					handleChange={handleChange}
					activeId={selectedProvider?.id}
					showResults={showResults}
					setShowResults={setShowResults}
					getPrescribers={getPrescribers}
					getGroupPractices={getGroupPractices}
					getGeographyAggregates={getGeographyAggregates}
					handleActive={handleActive}
					searchInput={searchInput}
					setSearchInput={setSearchInput}
					showMaxRecordsMessage={true}
					delaySearch={true}
					showHcpOpportunity={false}
				/>
			</Modal.Body>
			<Modal.Footer>
				<div className='container-fluid mx-0'>
					<div className='row justify-content-md-end px-0'>
						<div className='col-12 col-md-9 col-lg-7 px-0'>
							<div className='d-flex w-100 flex-column flex-md-row-reverse'>
								<button onClick={handleSelect} className='btn btn-primary btn-lg mb-3 mb-md-0 ms-md-3 flex-fill w-100'>
									{getConfigValue(appState.config?.Common?.Select, appState)?.Value || null}
								</button>
								<button onClick={handleHide} className='btn btn-secondary btn-lg flex-fill w-100' data-bs-dismiss='modal'>
									{getConfigValue(appState.config?.Common?.Cancel, appState)?.Value || null}
								</button>
							</div>
						</div>
					</div>
				</div>
			</Modal.Footer>
		</Modal>
	);
}

export default ProvidersModal;
